import * as logger from '../../logging/logger';
import { makeRequest } from '../makeRequest';

export async function downloadFile(method: 'GET' | 'POST', path: string, type: string, fileName?: string, data?: any) {
    try {
        const response = await makeRequest({ method, path, data, responseType: 'buffer' });
        if (response.status === 200) {
            const blob = await response.blob();
            const file = new Blob([blob], { type: type });
            const fileUrl = URL.createObjectURL(file);
            let tempLink = document.createElement('a');
            tempLink.style.display = 'none';
            tempLink.href = fileUrl;
            if (fileName) {
                tempLink.download = fileName;
            } else {
                tempLink.target = '_blank';
            }
            document.body.appendChild(tempLink);
            tempLink.click();

            setTimeout(function() {
                document.body.removeChild(tempLink);
                window.URL.revokeObjectURL(fileUrl);
            }, 200);
        } else {
            logger.log('Debug', `downloadFile: Error: ${response.statusText}`);
        }
    } catch (error) {
        logger.log('Debug', `downloadFile: Error: ${error.message}`);
    }
}
